import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.toggleVisibility();
    }, 10);
  }

  toggleVisibility(event) {
    const personalRadio = document.getElementById("visibility_personal");
    const sharedRadio = document.getElementById("visibility_shared");
    const sharingOptions = document.getElementById("sharing-options");
    
    if (!personalRadio || !sharedRadio) {
      return;
    }
    
    if (personalRadio.checked) {
      if (sharingOptions) {
        sharingOptions.style.display = "none";
        // Clear all checkboxes when switching to personal
        this.clearSharingCheckboxes();
      }
    } else if (sharedRadio.checked) {
      if (sharingOptions) {
        sharingOptions.style.display = "block";
        // Ensure at least client is checked when switching to shared
        this.ensureMinimumSharing();
      }
    }
    this.updateVisibilitySelection();
  }

  clearSharingCheckboxes() {
    const checkboxes = document.querySelectorAll("input[name='visibility_types[]']");
    if (checkboxes && checkboxes.length > 0) {
      checkboxes.forEach((checkbox) => {
        if (!checkbox.disabled) {
          checkbox.checked = false;
        }
      });
    }
  }

  ensureMinimumSharing() {
    const checkboxes = document.querySelectorAll("input[name='visibility_types[]']");
    
    if (checkboxes && checkboxes.length > 0) {
      const hasChecked = Array.from(checkboxes).some((checkbox) => checkbox.checked);
      
      if (!hasChecked) {
        const clientCheckbox = document.getElementById("visibility_client");
        if (clientCheckbox) {
          clientCheckbox.checked = true;
        }
      }
    }
  }

  updateVisibilitySelection() {
    const visibilityOptions = document.querySelectorAll(".visibility-option");
    
    if (visibilityOptions && visibilityOptions.length > 0) {
      visibilityOptions.forEach((option) => {
        const radio = option.querySelector("input[type='radio']");
        if (radio && radio.checked) {
          option.classList.add("selected");
        } else {
          option.classList.remove("selected");
        }
      });
    }
  }
}